import * as yup from 'yup';

export const schema = yup
  .object({
    des_titulo: yup.string().trim().min(1).required(),
    des_informacao: yup.string().trim().min(1).required(),
  })
  .required();
